"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const react_custom_scrollbars_1 = require("react-custom-scrollbars");
const Store_1 = require("../Store");
let Filter = class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.open = false;
        this.selectedBuffer = (0, mobx_1.observable)([]);
        this.node = null;
        (0, mobx_1.autorun)(function () {
            if (this.props.selectedFilters !== null) {
                this.selectedBuffer.replace(this.props.selectedFilters.slice());
            }
        }.bind(this));
    }
    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick.bind(this), false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick.bind(this), false);
    }
    toggleOpen() {
        this.open = !this.open;
    }
    Clear() {
        this.selectedBuffer.replace([]);
        this.props.onClear();
    }
    handleClick(e) {
        if (this.node !== null && !this.node.contains(e.target)) {
            this.open = false;
        }
    }
    onSelect(filter) {
        if (!this.props.multiselect) {
            this.toggleOpen();
            this.props.onSelect(filter);
        }
        else {
            var index = -1;
            if (this.selectedBuffer !== null) {
                index = this.selectedBuffer.map(x => x.id).indexOf(filter.id);
            }
            if (index > -1) {
                this.selectedBuffer.splice(index, 1);
            }
            else if (index < 0) {
                this.selectedBuffer.push(filter);
            }
            // We remove all selection from buffer if we select something else
            if (filter.id !== 0) {
                var allindex = this.selectedBuffer.map(x => x.id).indexOf(0);
                if (allindex > -1) {
                    this.selectedBuffer.splice(allindex, 1);
                }
            }
        }
    }
    renderThumb() {
        return (React.createElement("div", { className: "o-scrollthumb" }));
    }
    get getUrl() {
        if (this.selectedBuffer === null) {
            return Store_1.default.containerUrlSegment;
        }
        return Store_1.default.containerUrlSegment + this.selectedBuffer.map((x) => x.urlSegment).join(".");
    }
    get displayName() {
        if (this.props.multiselect) {
            return this.props.name + (this.selectedBuffer.length > 0 ? " (" + this.selectedBuffer.length + ")" : "");
        }
        else {
            return this.selectedBuffer !== null && this.selectedBuffer.length > 0 ? this.selectedBuffer[0].name : this.props.name;
        }
    }
    Show() {
        this.props.onSelect(this.selectedBuffer.toJS());
        this.toggleOpen();
    }
    onAllSelect() {
        this.open = false;
        this.props.allOnSelect();
    }
    render() {
        return (React.createElement("div", { className: "col-md-3 col-sm-6 col-xs-12" },
            React.createElement("div", { ref: node => this.node = node, className: "o-product-filter " + (this.props.active ? "active" : "") },
                React.createElement("div", { className: "o-product-filter-head", onClick: this.toggleOpen },
                    React.createElement("span", null, this.displayName),
                    React.createElement("span", { className: "arrow " + (this.open ? "flipped" : "") }, '\u25BC')),
                React.createElement("div", { className: "o-product-filter-options " + (this.open ? "open " : "") + (this.props.multiselect ? "multiselect " : "") },
                    React.createElement(react_custom_scrollbars_1.default, { autoHeight: true, autoHeightMax: 500, renderThumbVertical: this.renderThumb, renderTrackVertical: () => React.createElement("div", { className: "o-scrollthumb-track" }) },
                        React.createElement("div", { className: "options" },
                            React.createElement(react_router_dom_1.Link, { to: this.props.allLink, onClick: this.onAllSelect }, Store_1.default.Translations.allText),
                            this.props.filters && this.props.filters.map((filter, index) => {
                                var active = false;
                                if (this.selectedBuffer !== null) {
                                    active = this.selectedBuffer.some(x => x.id === filter.id);
                                }
                                if (this.props.multiselect) {
                                    return (React.createElement("div", { onClick: this.onSelect.bind(this, filter), className: active ? "active" : "", key: index },
                                        React.createElement("span", null,
                                            active ? '\u25CF' : '\u25CB',
                                            " "),
                                        filter.name));
                                }
                                else {
                                    return (React.createElement(react_router_dom_1.Link, { to: filter.url, onClick: this.onSelect.bind(this, filter), key: index }, filter.name));
                                }
                            }))),
                    this.props.multiselect &&
                        React.createElement("div", { className: "o-product-filter-controls" },
                            React.createElement(react_router_dom_1.Link, { to: Store_1.default.containerUrlSegment, onClick: this.Clear.bind(this) }, Store_1.default.Translations.clearText),
                            React.createElement(react_router_dom_1.Link, { to: this.getUrl, onClick: this.Show.bind(this) }, Store_1.default.Translations.showText))))));
    }
};
__decorate([
    mobx_1.observable
], Filter.prototype, "open", void 0);
__decorate([
    mobx_1.observable
], Filter.prototype, "selectedBuffer", void 0);
__decorate([
    mobx_1.action.bound
], Filter.prototype, "toggleOpen", null);
__decorate([
    mobx_1.action.bound
], Filter.prototype, "Clear", null);
__decorate([
    mobx_1.action.bound
], Filter.prototype, "handleClick", null);
__decorate([
    mobx_1.action.bound
], Filter.prototype, "onSelect", null);
__decorate([
    mobx_1.computed
], Filter.prototype, "getUrl", null);
__decorate([
    mobx_1.computed
], Filter.prototype, "displayName", null);
__decorate([
    mobx_1.action.bound
], Filter.prototype, "onAllSelect", null);
Filter = __decorate([
    mobx_react_1.observer
], Filter);
exports.default = Filter;
